export default "__VITE_ASSET__xndOCoyw__"